import { render, staticRenderFns } from "./FaceResultControl.vue?vue&type=template&id=6158f067&"
import script from "./FaceResultControl.vue?vue&type=script&lang=js&"
export * from "./FaceResultControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports